import { render, staticRenderFns } from "./user-manage.vue?vue&type=template&id=292a33c9"
import script from "./user-manage.vue?vue&type=script&lang=ts"
export * from "./user-manage.vue?vue&type=script&lang=ts"
import style0 from "./user-manage.vue?vue&type=style&index=0&id=292a33c9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports